import { AiOutlineHome, AiOutlinePlayCircle } from 'react-icons/ai';
import { Image } from 'antd';
import React from 'react';
import referAndEarn from '../assets/refer-and-earn.svg';
import clickedReferAndEarn from '../assets/clicked-refer-and-earn.svg';
import bagIcon from '../assets/bag.svg';
import clickedBagIcon from '../assets/clicked-bag.svg';
import testimonial_1 from '../assets/testimonial_1.svg'
import testimonial_2 from '../assets/testimonial_2.svg'
import testimonial_3 from '../assets/testimonial_3.svg'

const WELCOME_CONDITIONS = [
  'Work in your city and earn upto ₹ 30,000 per month',
  'Start earning within 24 hours of applying.',
  'Get personalised advice from the Mitra Job Specialists.',
  'All of this, for absolutely free!!!',
];
const NAVIGATION_ITEMS = [
  {
    key: 'jobListings',
    label: 'Jobs',
    navigationTo: 'local',
    URL: '/job-listings',
    icon(clicked = false) {
      return (
        <Image
          src={clicked ? clickedBagIcon : bagIcon}
          preview={false}
          width="21px"
          height="21px"
        />
      );
    },
  },
  // {
  //   key: 'mitraReferrals',
  //   label: 'Refer & Earn',
  //   navigationTo: 'native',
  //   URL: 'https://jsonplaceholder.typicode.com/comments/1',
  //   icon(clicked = false) {
  //     return (
  //       <Image
  //         src={clicked ? clickedReferAndEarn : referAndEarn}
  //         preview={false}
  //         width="21px"
  //         height="21px"
  //       />
  //     );
  //   },
  // },
  // {
  //   key: 'mitraVideos',
  //   label: 'Videos',
  //   URL: '/content/videos',
  //   navigationTo: 'local',
  //   icon(clicked = false) {
  //     return (
  //       <AiOutlinePlayCircle
  //         style={{ fontSize: '1.5em' }}
  //         color={clicked ? '#D86235' : '#888888'}
  //       />
  //     );
  //   },
  // },
];
const MIN_WELCOME_SCREEN_COUNT = 3;
export const MARKETPLACE_CONSTANTS = {
  WELCOME_CONDITIONS,
  NAVIGATION_ITEMS,
  MIN_WELCOME_SCREEN_COUNT,
};

export const JOB_DESCRIPTION = {
  RAPIDO: {
    cardInfo: 'Joining Bonus upto ₹1000',
    earningDetailsAndBenefits: [
      {
        id: 1,
        value: 'Zero Registration or Onboarding Fee.',
      },
      {
        id: 2,
        value:
          'Accidental coverage and medical benefits covered up to ₹5 Lakh for Captain & family.',
      },
      {
        id: 3,
        value: 'Get onboarded from your home, no need to visit Rapido Office.',
      },
      {
        id: 4,
        value:
          'Earnings can be transferred from Rapido wallet to your bank account at your convenience.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - None.',
      },
      {
        id: 1,
        value: 'Need your own vehicle and phone.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike (Geared or Ungeared), E-Bike, Cycle.',
      },
      {
        id: 3,
        value: 'Documents - Aadhar, PAN, DL, RC.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  RAPIDO_3PL: {
    cardInfo: 'Accidental Insurance Coverage of ₹5 lacs.',
    earningDetailsAndBenefits: [
      {
        id: 1,
        value: 'Zero Registration or Onboarding Fee.',
      },
      {
        id: 3,
        value: 'Get onboarded from your home, no need to visit Rapido Office.',
      },
      {
        id: 4,
        value: 'Daily income cashout available on Mitra app.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - None.',
      },
      {
        id: 1,
        value: 'Need your own vehicle and phone.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike (Geared or Ungeared), E-Bike, Cycle.',
      },
      {
        id: 3,
        value: 'Documents - Aadhar, PAN, DL, RC.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  UBER: {
    cardInfo: 'Joining Bonus upto ₹2000.',
    earningDetailsAndBenefits: [
      {
        id: 1,
        value: 'Zero Registration or Onboarding Fee.',
      },
      {
        id: 2,
        value: 'Accidental Insurance upto 5L.',
      },
      {
        id: 3,
        value: 'Daily payment to your bank account.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - None.',
      },
      {
        id: 1,
        value: 'Need your own vehicle and phone.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike (Geared or Ungeared), E-Bike, Cycle.',
      },
      {
        id: 3,
        value: 'Documents - Aadhar, PAN, DL, RC.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  ZOMATO: {
    cardInfo: 'Joining Bonus upto ₹3,000.',
    earningDetailsAndBenefits: [
      {
        id: 0,
        value: 'Free Tshirt and bag delivered to your doorstep.',
      },
      {
        id: 1,
        value: 'Get onboarded from your home, no need to visit Zomato Office.',
      },
      {
        id: 2,
        value: 'Ability to book slots 3 days in advance.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - None.',
      },
      {
        id: 1,
        value: 'Need your own vehicle and phone.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike (Geared or Ungeared), E-Bike, Cycle.',
      },
      {
        id: 3,
        value: 'Documents - PAN, DL, Bank Details.',
      },
      {
        id: 4,
        value: 'Onboarding Fee Upto ₹ 3000.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  ZOMATO_3PL: {
    cardInfo: 'Accidental Insurance Coverage of ₹3 lacs.',
    earningDetailsAndBenefits: [
      {
        id: 0,
        value: 'Zero Registration or Onboarding Fee.',
      },
      {
        id: 1,
        value: 'Daily income cashout available on Mitra app.',
      },
      {
        id: 2,
        value: 'Get onboarded from your home, no need to visit Zomato Office.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - None.',
      },
      {
        id: 1,
        value: 'Need your own vehicle and phone.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike (Geared or Ungeared), E-Bike, Cycle.',
      },
      {
        id: 3,
        value: 'Documents - PAN, DL, Bank Details.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  ZEPTO_3PL: {
    cardInfo: 'Accidental Insurance Coverage of ₹2 lacs.',
    earningDetailsAndBenefits: [
      {
        id: 0,
        value: 'Attractive weekly and monthly incentives along with minimum guarantee.',
      },
      {
        id: 1,
        value: 'Short distance delivery (<3km).',
      },
      {
        id: 2,
        value:
          'Proper sitting areas at the store. Riders have washroom accessibility,drinking water etc.',
      },
      {
        id: 3,
        value: 'High demand: 20-40 orders/day.',
      },
      {
        id: 4,
        value: 'Zepto provides it’s own cycle free of cost.',
      },
      {
        id: 5,
        value: 'Daily income cashout available on Mitra app.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - None.',
      },
      {
        id: 1,
        value: 'Need your own vehicle and phone.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike, E-Bike, Cycle.',
      },
      {
        id: 3,
        value: 'Documents - Aadhar, PAN, DL, Bank account passbook/cheque.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  DELHIVERY_3PL: {
    cardInfo: 'Accidental Insurance Coverage of ₹3 lacs.',
    earningDetailsAndBenefits: [
      {
        id: 0,
        value: 'Ecommerce delivery : Get paid per packet.',
      },
      {
        id: 1,
        value: 'Pick up multiple packets in one go.',
      },
      {
        id: 2,
        value: 'Shift timings : 8AM - 1PM and 1PM - 6PM.',
      },
      {
        id: 3,
        value: 'Earning Potential - Upto 40k/month.',
      },
      {
        id: 4,
        value: 'Accidental insurance of 3 lacs and health insurance of 1 lac from day 1.',
      },
    ],
    joiningRequirements: [],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  SWIGGY: {
    cardInfo: '',
    earningDetailsAndBenefits: [
      {
        id: 0,
        value: 'Potential earnings of upto 35,000 per month.',
      },
      {
        id: 1,
        value: 'Part-time work opportunity also available.',
      },
      {
        id: 2,
        value: 'T-shirt is given by the company.',
      },
      {
        id: 3,
        value: 'Very good incentive plans.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Documents- Driving License, Aadhar Card, PAN Card.',
      },
      {
        id: 1,
        value: 'Bank documents : Passbook / Canceled cheque.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  DUNZO: {
    cardInfo: 'Joining Bonus upto ₹ 6,000 .',
    earningDetailsAndBenefits: [
      {
        id: 0,
        value: 'Potential earnings of upto 35,000 per month.',
      },
      {
        id: 1,
        value: 'No fixed timings, Dunzo operates 24 X 7.',
      },
      {
        id: 2,
        value:
          'Staying active on the platform during the peak hours will help the partner earn more due to high demand.',
      },
      {
        id: 3,
        value: 'T-shirts and Bags are given by the company.',
      },
      {
        id: 4,
        value: 'Very good incentive plans',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - None.',
      },
      {
        id: 1,
        value: 'Need your own vehicle and phone.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike (Geared or Ungeared).',
      },
      {
        id: 3,
        value: 'Documents - PAN, Aadhar Card, DL, Bank Details, RC details.',
      },
      {
        id: 4,
        value: 'Registration Fee of ₹1200.',
      },
    ],
    timings: [
      {
        id: 0,
        value: 'Flexible Timings.',
      },
    ],
  },
  FLIPKART: {
    cardInfo: 'Accidental Insurance Coverage of ₹5 lacs.',
    earningDetailsAndBenefits: [
      {
        id: 0,
        value: 'Tshirt and bag to be provided by company.',
      },
      {
        id: 1,
        value: 'Get onboarded from your home, start working in 48 hours.',
      },
      {
        id: 2,
        value: 'Work near your home, get placed to the hub closest to your home.',
      },
      {
        id: 3,
        value: 'Option of working on 2 shifts - Morning or afternoon.',
      },
      {
        id: 4,
        value: 'Get weekly payouts no need to wait for the month to end.',
      },
    ],
    joiningRequirements: [
      {
        id: 0,
        value: 'Educational Requirements - Class 10th Pass.',
      },
      {
        id: 1,
        value: 'Need a 2wheeler - Own or on someone else’s name is ok.',
      },
      {
        id: 2,
        value: 'Vehicles Allowed - Bike (Geared or Ungeared), E-Bike.',
      },
      {
        id: 3,
        value: 'Documents - PAN, DL, Bank Details (passbook / canceled cheque), Adhaar card.',
      },
    ],
    timings: [],
  },
};

export const JOB_VIDEO_LINKS = {
  RAPIDO: 'https://www.youtube.com/watch?v=hjzxNeO36R4',
  UBER: 'https://www.youtube.com/watch?v=M532erqYP88',
  ZOMATO: 'https://www.youtube.com/watch?v=mrxir40VwZ0',
  ZEPTO: '',
  DELHIVERY: '',
  SWIGGY: '',
  DUNZO: '',
  FLIPKART: '',
};

export const APPLICABLE_JOBS = [
  'zepto_3pl',
  'rapido_3pl',
  'rapido',
  'uber',
  'zomato_3pl',
  'delhivery_3pl',
  'swiggy',
  'dunzo',
  'zomato',
  'flipkart',
  'bigbasket_3pl'
];

export const qualificationsTranslationsMap = {
  below_9: '9th Class or below',
  class_10: '10th Pass',
  class_12: '12th Pass',
  diploma: 'Diploma',
  iti: 'ITI',
  graduate: 'Graduate',
  pg: 'Post Graduate',
};

export const salaryRangeMap = {
  ten_15K: '₹10,000 - ₹15,000',
  fiften_20k: '₹15,000 - ₹20,000',
  twenty_30k: '₹20,000 - ₹30,000',
  thirty_40k: '₹30,000 - ₹40,000',
  more_40k: 'More than ₹40,000',
};

export const companyWiseMaxSalary = {
  RAPIDO: '30,000',
  RAPIDO_3PL: '30,000',
  ZOMATO: '30,000',
  ZOMATO_3PL: '30,000',
  UBER: '30,000',
  UBER_3PL: '30,000',
  ZEPTO: '40,000',
  ZEPTO_3PL: '40,000',
  DELHIVERY: '40,000',
  DELHIVERY_3PL: '40,000',
  SWIGGY: '35,000',
  DUNZO: '30,000',
  FLIPKART: '30,000',
};

export const DEFAULT_VIDEO_COUNT = 20;

export const jobDistance = {
  rapido_3pl: 6,
  rapido: 6,
  uber: 6,
  zomato: 5,
  zomato_3pl: 5,
  zepto: 5,
  zepto_3pl: 5,
  delhivery_3pl: 7,
  swiggy: 7,
  flipkart: 7,
  dunzo: 7,
  bigbasket: 7,
  bigbasket_3pl: 7
};

export const ratingsData = {
  rapido_3pl: {
    rating: 4.3,
    ratingCnt: '2 L',
  },
  rapido: {
    rating: 4.3,
    ratingCnt: '2 L',
  },
  uber: {
    rating: 4.6,
    ratingCnt: '32 L',
  },
  zomato: {
    rating: 4,
    ratingCnt: '8 T',
  },
  'zomato-3pl': {
    rating: 4,
    ratingCnt: '8 T',
  },
  zepto: {
    rating: 4.4,
    ratingCnt: '5 T',
  },
  zepto_3pl: {
    rating: 4.4,
    ratingCnt: '5 T',
  },
  "delhivery_3pl": {
    "rating": 4.3,
    "ratingCnt": "120"
  },
  swiggy: {
    rating: 3.9,
    ratingCnt: '2 L',
  },
  flipkart: {
    rating: 3.9,
    ratingCnt: '1 T',
  },
  dunzo: {
    rating: 3.8,
    ratingCnt: '17 T',
  }
};
export const jobTypes = {
  UNAVAILABLE: 'unavailable',
  COMING_SOON: 'comingSoon',
};

export const duplicatePopupText = {
  comingSoonJobs: {
    unavailableText: 'Our team is working hard to bring this job opportunity for you.',
    otherOpportunityText: "However why don't you checkout other available opportunities.",
  },
  alreadyAppliedJobsInfoFromJobListingsPage: {
    unavailableText: 'Unfortunately, this job has become unavailable.',
    otherOpportunityText: 'However there are other exciting opportunities waiting for you.',
  },
  alreadyAppliedJobs: {
    unavailableText: "Unfortunately, this job isn't available at the moment.",
    otherOpportunityText: 'However there are other exciting opportunities waiting for you.',
  },
};

export const jobListingPageTopCarousel = {
  carouselContent: [
    {
      text: "Don't miss your chance to apply to top jobs!",
      isDynamic: false,
    },
    {
      text: 'Monthly report: {200-250_monthlyReport} hired in {city}!',
      isDynamic: true,
    },
    {
      text: '{name} started his job in {client} today.',
      isDynamic: true,
    },
  ],
  carouselBackground: '#E9EBFF',
  carouselTextColor: '#3D4EC6',
  carouselInterval: 5000,
};

export const applicationStatusPageCarousel = {
  carouselContent: [
    {
      text: "Don't miss out - apply before job is filled in your area!",
      isDynamic: false,
    },
    {
      text: 'Breaking: {25-50_workersPlacedWeekly} workers got jobs in your area this week!',
      isDynamic: true,
    },
    {
      text: 'Success story: {name} got a job in your area 1hr ago!',
      isDynamic: true,
    },
  ],
  carouselBackground: '#E9EBFF',
  carouselTextColor: '#3D4EC6',
  carouselInterval: 5000,
};

export const successfullyAppliedPageCarousel = {
  carouselContent: [
    {
      pageOne: {
        title: 'Good Job',
        text: 'You have successfully applied for the Zepto Job',
      },
    },
    {
      pageTwo: {
        title: 'Application Created',
        text: 'Job specialist is ready. They are waiting for you to upload your documents',
      },
    },
  ],
};

export const jobListingPageTestimonials = {
  allTestimonials: [
    {
      testimonial:
        'Mitra helped me find a delivery job that fits me perfectly. They have all the best jobs in {city}.',
      testimonialBy: '- Akash',
      cardBg: '#FFF1D2',
      textColor: '#3C3C3C',
      nameTextColor: '#D34B18',
      testimonialImg: testimonial_1
    },
    {
      testimonial:
        "After applying, I sent my documents to Mitra's job specialist. They helped me get the job the same day.",
      testimonialBy: '- Attri',
      cardBg: '#FFF1D2',
      textColor: '#3C3C3C',
      nameTextColor: '#D34B18',
      testimonialImg: testimonial_2
    },
    {
      testimonial:
        "Delivery job is a good part-time work. I get to earn extra income while still having time for my studies.",
      testimonialBy: 'Shashank',
      cardBg: '#FFF1D2',
      textColor: '#3C3C3C',
      nameTextColor: '#D34B18',
      testimonialImg: testimonial_3
    },
  ],
};

export const companySpecificTestimonials = {
  allTestimonials: [
    {
      forCompany: 'Zepto',
      testimonial:
        'Zepto is great! Working and staying in the same area means continuous orders and good salary for hard work.',
      testimonialBy: '- Ramji',
      cardBg: '#3E125C',
      textColor: '#FFFFFF',
      nameTextColor: '#F13333',
    },
    {
      forCompany: 'Zepto_3PL',
      testimonial:
        'Zepto is great! Working and staying in the same area means continuous orders and good salary for hard work.',
      testimonialBy: '- Ramji',
      cardBg: '#3E125C',
      textColor: '#FFFFFF',
      nameTextColor: '#F13333',
    },
    {
      forCompany: 'Swiggy',
      testimonial:
        'Swiggy pays well for peak hours if you work hard. They offer medical and accidental insurance.',
      testimonialBy: '- Arjun',
      cardBg: '#FC8019',
      textColor: '#FFFFFF',
      nameTextColor: '#75290D',
    },
    {
      forCompany: 'Dunzo',
      testimonial:
        "I love working for Dunzo! Serving my local area means continuous orders and good pay. It's a good experience.",
      testimonialBy: '- Atta',
      cardBg: '#01FFA7',
      textColor: '#083626',
      nameTextColor: '#182932',
    },
    {
      forCompany: 'Uber',
      testimonial:
        "Working for Uber feels like my own business. Customers are friendly, pay is good. It's a perfect job!",
      testimonialBy: '- Ranjeet',
      cardBg: '#010202',
      textColor: '#FFFFFF',
      nameTextColor: '#FFFFFF',
    },
    {
      forCompany: 'Rapido',
      testimonial:
        "No one knows I'm working for Rapido. The customers are nice, and it's better than food delivery.",
      testimonialBy: '- Yousuf',
      cardBg: '#FFCA0A',
      textColor: '#1F1F1F',
      nameTextColor: '#000000',
    },
    {
      forCompany: 'Rapido_3PL',
      testimonial:
        "No one knows I'm working for Rapido. The customers are nice, and it's better than food delivery.",
      testimonialBy: '- Yousuf',
      cardBg: '#FFCA0A',
      textColor: '#1F1F1F',
      nameTextColor: '#000000',
    },
    {
      forCompany: 'Zomato',
      testimonial:
        'I feel good to work for Zomato. The team is supportive, work is flexible, and pay is high during peak hours.',
      testimonialBy: '- Saroj',
      cardBg: '#F20E49',
      textColor: '#FFFFFF',
      nameTextColor: '#5F0D22',
    },
    {
      forCompany: 'Flipkart',
      testimonial:
        'In Flipkart they give me a route and I delivery in that route. There is no stress as long I give the orders correctly.',
      testimonialBy: '- Surya',
      cardBg: '#027CD5',
      textColor: '#FFFFFF',
      nameTextColor: '#FFE800',
    },
    {
      forCompany: 'Delhivery',
      testimonial:
        'Mitra helped me get work with Delhivery. I am really happy and enjoying my work, I get paid timely through the app',
      testimonialBy: '- Rohit',
      cardBg: '#060709',
      textColor: '#FFFFFF',
      nameTextColor: '#F14034',
    },
    {
      forCompany: 'Delhivery_3PL',
      testimonial:
        'Mitra helped me get work with Delhivery. I am really happy and enjoying my work, I get paid timely through the app',
      testimonialBy: '- Rohit',
      cardBg: '#060709',
      textColor: '#FFFFFF',
      nameTextColor: '#F14034',
    },
    {
      forCompany: 'Bigbasket_3PL',
      testimonial:
        'Joining Big Basket was the best decision I made! Payment is on time and support team is friendly & helpful.',
      testimonialBy: '- Dhruvin',
      cardBg: '#A0CD4A',
      textColor: '#000000',
      nameTextColor: '#F61B2C',
    },
  ],
};

export const random_male_names = {
  nameList: [
    'Aarav',
    'Dev',
    'Farhan',
    'Ishan',
    'Kabir',
    'Naveen',
    'Omar',
    'Rishabh',
    'Siddharth',
    'Yuvraj',
    'Aditya',
    'Bharat',
    'Chirag',
    'Dinesh',
    'Eshaan',
    'Gaurav',
    'Harsh',
    'Ishaq',
    'Jai',
    'Kunal',
    'Navin',
    'Pranav',
    'Tarun',
  ],
};

export const random_city_names = {
  cityList: ['Bangalore', 'Mumbai', 'Pune', 'Hyderabad', 'Chennai', 'Kolkata', 'Rajasthan'],
};

export const random_client_names = {
  cityList: ['Zepto', 'Zomato', 'Swiggy', 'Flipkart', 'Rapido', 'Uber', 'Delhivery'],
};

export const supportedLanguages = [
  {
    label: 'English',
    key: 'en',
    active: false
  },
  {
    label: 'Hindi + English',
    key: 'hi-Latn',
    active: false
  },
  {
    label: 'Kannada + English',
    key: 'kn-Latn',
    active: false
  },
  {
    label: 'Telugu + English',
    key: 'te-Latn',
    active: false
  }
];

export const forceUpdateVersion = 87;
